import { render, staticRenderFns } from "./InstructionTypeCreateEdit.vue?vue&type=template&id=c2d94d24&scoped=true&"
import script from "./InstructionTypeCreateEdit.vue?vue&type=script&lang=js&"
export * from "./InstructionTypeCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./InstructionTypeCreateEdit.vue?vue&type=style&index=0&id=c2d94d24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d94d24",
  null
  
)

export default component.exports